import { HStack } from "@chakra-ui/react";
import React from "react";

import { SearchSelect, SearchSelectProperties } from "../SearchSelect";
import { ProductStatusTag } from "./ProductStatusTag";
import { getProductStatusLabel, ProductStatus } from "./productStatusConfig";

const statusOptions = Object.values(ProductStatus).map((value) => ({
  label: getProductStatusLabel(value),
  value,
}));

interface ProductStatusSelectProps
  extends Omit<
    SearchSelectProperties<(typeof statusOptions)[0]>,
    "options" | "getOptionLabel" | "renderOption" | "onChange" | "value"
  > {
  value: ProductStatus | null;
  onChange: (status: ProductStatus | null) => void;
}

export const ProductStatusSelect: React.FC<ProductStatusSelectProps> = ({
  value,
  onChange,
  placeholder = "Sélectionner un statut",
  isClearable = false,
  ...rest
}) => {
  return (
    <SearchSelect<(typeof statusOptions)[0]>
      getOptionLabel={(option) => option.label}
      placeholder={placeholder}
      isClearable={isClearable}
      onChange={(option: (typeof statusOptions)[0] | null) => {
        onChange(option?.value ?? null);
      }}
      renderOption={({ data }) => (
        <HStack gap={2} w="full">
          <ProductStatusTag status={data.value} />
        </HStack>
      )}
      singleValue={({ data }) => <ProductStatusTag status={data.value} />}
      options={statusOptions}
      value={statusOptions.find((option) => option.value === value) ?? null}
      {...rest}
    />
  );
};
